import { Box, Grid } from '@mui/material';
import { ReleaseParty } from 'modules/global/adapters/crpAPI';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IUploadReleaseRightsFileRequestUi } from 'modules/global/adapters/crpAPI';

type Props = {
  values: IUploadReleaseRightsFileRequestUi;
  selectedReleaseParty: ReleaseParty | null;
};

const UploadCsvStep = ({ values, selectedReleaseParty }: Props) => {
  const { t } = useTranslation(['uploadcsv']);

  return (
    <React.Fragment>
      <Box style={{ paddingLeft: 20 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 12 }}>
            {t('uploadcsv:uploadStep.labelReadyToUpload')} {values.file?.name}
          </Grid>
          {values.file?.type !== 'text/csv' && (
            <Grid size={{ xs: 12, sm: 12 }} style={{ color: 'red' }}>
              {t('uploadcsv:uploadStep.labelWarningNotCsvFile')}
            </Grid>
          )}
          <Grid size={{ xs: 12, sm: 12 }}>
            {t('uploadcsv:uploadStep.labelSelectedReleaseParty')}{' '}
            {!selectedReleaseParty
              ? t('uploadcsv:uploadStep.labelSelectedReleasePartyNone')
              : selectedReleaseParty.name + '(' + selectedReleaseParty.nxtEntityId + ')'}
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
};
export default UploadCsvStep;
